var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c(
      "div",
      {
        class: [
          _vm.$style.message,
          ((_obj = {}), (_obj[_vm.$style.messageRow] = _vm.hideAction), _obj)
        ]
      },
      [
        _vm.$slots["above-message"]
          ? _c(
              "div",
              { class: _vm.$style.aboveMessage },
              [_vm._t("above-message")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.actions },
      [
        !_vm.hideAction
          ? [
              _vm.actionType === "login"
                ? _c(
                    "button",
                    {
                      staticClass: "primary-outline fluid",
                      class: _vm.$style.button,
                      on: { click: _vm.handleLoginRequest }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.actionLabel) + "\n      "
                      )
                    ]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "primary-outline fluid",
                      class: _vm.$style.button,
                      attrs: { href: _vm.actionUrl }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.actionLabel) + "\n      "
                      )
                    ]
                  )
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.hideSecondaryAction
          ? _c(
              "a",
              {
                staticClass: "hit-outline fluid",
                class: _vm.$style.button,
                attrs: { href: _vm.secondaryActionHref }
              },
              [_vm._v("\n      " + _vm._s(_vm.secondaryActionLabel) + "\n    ")]
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.$slots["after-action"]
      ? _c(
          "div",
          { class: _vm.$style.afterAction },
          [_vm._t("after-action")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }